module.exports = __webpack_public_path__ + "3891720efe76f0a793812c1958ec1ae6.png";